import { api } from './client';

export type ConsentChannel = 'sms' | 'email';
export type ConsentKind = 'serviciu' | 'publicitate';

/** Decizia curentă pe un canal și un tip. Oglindește `ConsentState`. */
export interface ConsentState {
  channel: ConsentChannel;
  kind: ConsentKind;
  /** `true`, `false`, sau `null` — nedecis. */
  granted: boolean | null;
  source: 'receptie' | 'portal' | null;
  decidedAt: string | null;
}

/** Exact câmpurile `SetConsentDto`. */
export interface SetConsentInput {
  channel: ConsentChannel;
  kind: ConsentKind;
  granted: boolean | null;
}

/** Un rând din istoricul comunicării. Oglindește `CommunicationEntry`. */
export interface CommunicationEntry {
  at: string;
  /** `apel`: un apel de pe listele de sunat (plan neînceput, rechemare). */
  source: 'regula' | 'reamintire' | 'portal' | 'apel';
  label: string;
  channel: string | null;
  /** La un apel: rezultatul lui (`nerespuns`, `revine`, `se_gandeste`, `refuz`, `programat`). */
  status: string | null;
  detail: string | null;
  from: string | null;
  to: string | null;
  /** La un apel: cine a sunat. */
  by: string | null;
}

export const consentsApi = {
  /** Tot ce i s-a trimis pacientului și tot ce a scris, cele mai noi primele (M6). */
  communications: (patientId: string, page: { limit?: number; offset?: number } = {}) =>
    api.get<{ entries: CommunicationEntry[]; hasMore: boolean }>(
      `/patients/${patientId}/communications`,
      { query: page },
    ),

  forPatient: (patientId: string) =>
    api.get<ConsentState[]>(`/patients/${patientId}/communication-consents`),
  setForPatient: (patientId: string, body: SetConsentInput) =>
    api.put<ConsentState[]>(`/patients/${patientId}/communication-consents`, body),

  /** Un SMS scris din fișă, trimis prin clinică (M5). Rămâne în istoricul comunicării. */
  sendSms: (patientId: string, text: string) =>
    api.post<{ status: 'sent' | 'failed' | 'skipped'; reason: string | null }>(
      `/patients/${patientId}/communications/sms`,
      { text },
    ),

  /** Portalul: preferințele pacientului autentificat. */
  mine: () => api.get<ConsentState[]>('/portal/communication-consents'),
  setMine: (body: SetConsentInput) =>
    api.put<ConsentState[]>('/portal/communication-consents', body),
};
